import api from '../utils/api';
import config from '../config';

const violationReportService = {
  // Get init data (units list)
  getInit: async () => {
    return api.get(config.endpoints.reports.init);
  },

  // Get violation report by unitId and date range
  getViolationReport: async (params = {}) => {
    const reportParams = {
      UnitId: params.unitId,
      FromDate: params.fromDate,
      ToDate: params.toDate,
    };

    return api.get(config.endpoints.reports.violation, reportParams);
  },

  // Export violation report to Excel/PDF by date range
  exportViolationReportToExcel: async (params = {}) => {
    const exportParams = {
      UnitId: params.unitId,
      FromDate: params.fromDate,
      ToDate: params.toDate,
    };

    // Add type parameter if provided (for PDF export)
    if (params.type) {
      exportParams.type = params.type;
    }

    const response = await api.get(config.endpoints.reports.violationExport, exportParams, {
      responseType: 'blob',
    });

    // Determine file extension based on type
    const isPdf = params.type === 'pdf';
    const extension = isPdf ? 'pdf' : 'xlsx';
    const fileName = `ViolationReport_${params.fromDate}_${params.toDate}.${extension}`;

    // Trigger download
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return { message: isPdf ? 'PDF file downloaded successfully' : 'Excel file downloaded successfully' };
  },
};

export default violationReportService;
